// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmationInfo_root__giEOE","info":"ConfirmationInfo_info__21QWH"};